import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedMatchGuard implements CanMatch {
  constructor(private readonly authService: AuthService) {}

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> | boolean {
    return this.authService.check().pipe(map((authenticated) => authenticated));
  }
}
